import { createReducer, on } from '@ngrx/store';
import { dashboard } from 'src/app/models';
import { DialogExportReportToDashboardTypes } from 'src/app/reports/reports-details/nested-components/reports-dialog-export/reports-dialog-export.component';
import { dashboardConfig } from '../models';
import * as actions from './actions';

export interface dashboardState {
    dashboards: dashboard[];
    isDirty: boolean;
    error: string;
    currentDashboardId?: number;
    dashboardConfig:dashboardConfig;
    dashboardIdsForLoad: number[];
}

const initialState: dashboardState = {
  dashboards: [],
  isDirty: false,
  error: '',
  dashboardIdsForLoad: [],
  dashboardConfig: {
    isDefault: true,
    widgetRefreshInterval: { realTime: 10, traffic: 180, wfm: 10 },
    maxWidgetsPerDashboard: 20,
    maxDashboards: 30
  },
};

export const dashboardReducer = createReducer<dashboardState>(
    initialState,
    on(actions.addDashboard, (state, action): dashboardState => {
        let tmpId = getUniqueDashboardId(state.dashboards);
        let isFirstDashboard: boolean = state.dashboards.length == 0;
        return {
          ...state,
          dashboards: [...state.dashboards,
          {
            ...action.dashboard, id: tmpId, isNew: true,
            tabs: [{
              name: "Tab 1",
              id: getUniqueTabId(state.dashboards),
              isNew: true,
              gridItems: []
            }]
          }],
          isDirty: (isFirstDashboard ? false : true) || state.isDirty,
          currentDashboardId: tmpId,
          error: ''
        };
    }),
    on(actions.selectDashboard, (state, action): dashboardState => {
        let id: number = action.dashboard.id;
        return {
            ...state,
          currentDashboardId: id
        };
    }),
    on(actions.handleExportedDashboard, (state, action): dashboardState => {
      let exportedDashboardData, exportedDashboardId: number, dashboards: dashboard[], exportedDashboard: dashboard, type: DialogExportReportToDashboardTypes,
        currentDashboardId: number, isNew: boolean;

      exportedDashboardData = action.exportedDashboardData;
      exportedDashboardId = exportedDashboardData.id;
      type = exportedDashboardData.type;
      dashboards = state.dashboards;
      exportedDashboard = dashboards.find(d => d.id == exportedDashboardId);
      currentDashboardId = state.currentDashboardId;
      isNew = type === DialogExportReportToDashboardTypes.CreateNew;

      if (exportedDashboard) {
        if (isNew) {
          exportedDashboard.visible = true;
          currentDashboardId = exportedDashboard.id;
        } else if (exportedDashboard.visible) {
          currentDashboardId = exportedDashboard.id;
        }
      }

      return {
        ...state,
        dashboards: dashboards,
        //isDirty: true,
        currentDashboardId: currentDashboardId
      };
    }),
    on(actions.removeDashboard, (state, action): dashboardState => {
        let id = action.dashboard.id
        let currentIndex = state.dashboards.filter(d => d.visible).indexOf(state.dashboards.find(d => d.id == id));
        let updatedDashboards = state.dashboards.filter(item => item.id !== id);
        var filtered = updatedDashboards.filter(d => d.visible);
        var newIndex = currentIndex - 1;
        if (newIndex > filtered.length - 1) newIndex = filtered.length - 1;
        if (newIndex < 0) newIndex = 0;
        let currentDashboardId = filtered[newIndex].id

        return {
            ...state,
            dashboards: updatedDashboards,
            isDirty: true,
            currentDashboardId: currentDashboardId,
        };
    }),
    on(actions.ClearCurrentDashboard, (state, action): dashboardState => {
        return {
            ...state,
            dashboards: state.dashboards.map(d => d.id === state.currentDashboardId ? ({ ...d, tabs:d.tabs.map(t => ({ ...t, gridItems:[]}))}) : d),
            isDirty: true
        };
    }),
    on(actions.updateDashboardName, (state, action): dashboardState => {
        return {
            ...state,
            dashboards: state.dashboards.map(d => d.id === action.dashboard.id ? ({ ...d, name: action.newName }) : d),
            isDirty: true
        };
    }),
    on(actions.updateDashboardOwner, (state, action): dashboardState => {
      return {
        ...state,
        dashboards: state.dashboards.map(d => d.id === action.dashboard.id ? ({ ...d, ownerName: action.owner.name }) : d),
        isDirty: true
      }
    }),
    on(actions.updateDashboardAccess, (state, action): dashboardState => {
        return {
          ...state,
          dashboards: state.dashboards.map(d => d.id === action.dashboard.id ? ({ ...d, isPublic: action.isPublic, isAccessChanged: !d.isAccessChanged }) : d),
          isDirty: true
        };
    }),
    on(actions.updateDashboardAllowNonOwnersToEdit, (state, action): dashboardState => {
        return {
          ...state,
          dashboards: state.dashboards.map(d => d.id === action.dashboard.id ? ({ ...d, allowNonOwnersToEdit: action.allowOthersToEdit, isAllowNonOwnersToEditChanged: !d.isAllowNonOwnersToEditChanged }) : d),
          isDirty: true
        };
    }),
    on(actions.updateDashboardSettings, (state, action): dashboardState => {
        let currentDashboardId = state.currentDashboardId
        let currentIndex =state.dashboards.filter(d=>d.visible).indexOf(state.dashboards.find(d=>d.id==currentDashboardId));
        let dashboards = action.dashboars.slice().sort((a:dashboard,b:dashboard)=>a.orderNo-b.orderNo);

        if(!dashboards.find(d=>d.id==state.currentDashboardId).visible){
            var filtered = dashboards.filter(d=>d.visible);
            var newIndex = currentIndex-1;
            if(newIndex>filtered.length-1) newIndex = filtered.length-1;
            if(newIndex<0) newIndex = 0;
            currentDashboardId = filtered[newIndex].id
        }
        return {
            ...state,
            dashboards: dashboards,
            currentDashboardId:currentDashboardId,
            isDirty: true
        };
    }),
    on(actions.loadDashboardById, (state, action): dashboardState => {
        return {
            ...state,
            dashboardIdsForLoad:action.dashboarIds
        };
    }),
    //-- Grid Items -------------------------//
    on(actions.addWidget, (state, action): dashboardState => {
        let id = getUniqueGridItemId(state.dashboards)
        let dashboards: dashboard[] = state.dashboards.map(d => d.id !== state.currentDashboardId ? d : ({
            ...d,
            tabs: d.tabs.map(t => (
                { ...t, gridItems: [...t.gridItems, ({ ...action.gridItem, id: id, isNew: true })] }
            ))
        }));
        return {
            ...state,
            dashboards: dashboards,
            isDirty: true,
        };
    }),
    on(actions.updateWidget, (state, action): dashboardState => {
        let id: number = action.gridItem.id;
        let wg = action.gridItem;
        let dashboards: dashboard[] = state.dashboards.map(d => d.id !== state.currentDashboardId ? d :
            ({
                ...d, tabs: d.tabs.map(t => ({
                    ...t, gridItems: t.gridItems.map(w => w.id !== id ? w :
                        ({
                            ...w,
                            cols: wg.cols,
                            rows: wg.rows,
                            x: wg.x,
                            y: wg.y,
                            title: wg.title,
                            colorScheme: wg.colorScheme,
                            setup: wg.setup,
                            type: wg.type
                        }))
                }))
            }));

        return {
            ...state,
            dashboards: dashboards,
            isDirty: true,

        };
    }),
    on(actions.removeWidget, (state, action): dashboardState => {
        let dashboards: dashboard[] = state.dashboards.map(d =>
            d.id !== state.currentDashboardId ? d :
                ({
                    ...d,
                    tabs: d.tabs.map(t => ({
                        ...t,
                        gridItems: t.gridItems.filter(w => w.id !== action.gridItem.id)
                    }))
                }));
        return {
            ...state,
            dashboards: dashboards,
            isDirty: true,
        };
    }),

    //-- API -------------------------//

    on(actions.loadDashboardSuccess, (state, action): dashboardState => {
      let currentDashboardId: number = state.currentDashboardId;
      if (!action.dashboards.find(d => d.id == currentDashboardId && d.visible)) {
        let currentIndex = state.dashboards.filter(d => d.visible).indexOf(state.dashboards.find(d => d.id == currentDashboardId)) - 1;
        if (currentIndex < 0) { currentIndex = 0; }
        if (action.dashboards.filter(d => d.visible).length <= currentIndex) {
          currentIndex = action.dashboards.filter(d => d.visible).length - 1;
        }
        currentDashboardId = action.dashboards.filter(d => d.visible)[currentIndex]?.id
      }

      let dashboards = [...action.dashboards];
      if (dashboards.length == 0) {
        dashboards.push({
          id: getUniqueDashboardId(state.dashboards),
          name: "Dashboard 1",
          isNew: true,
          visible: true,
          isFavorite: false,
          orderNo: 99999,
          allowNonOwnersToEdit: false,
          tabs: [{
            name: "Tab 1",
            id: getUniqueTabId(state.dashboards),
            isNew: true,
            gridItems: []
          }]
        });
      }
      return {
        ...state,
        dashboards: dashboards,
        isDirty: false,
        error: '',
        currentDashboardId: currentDashboardId
      };
    }),
    on(actions.loadDashboardConfigSuccess, (state, action): dashboardState => {
      return {
        ...state,
        dashboardConfig: { ...action.config, isDefault: false }
      };
    }),
    on(actions.saveDashboardSuccess, (state, action): dashboardState => {
        let selectedDashboardId = action.dashboards.find(d => d.id == state.currentDashboardId || d.tmpId == state.currentDashboardId)?.id;
        if (!selectedDashboardId && action.dashboards.length > 0) {
            selectedDashboardId = action.dashboards[0].id;
        }
        let dashboards = action.dashboards.map(d => ({ ...d, tmpId: null }));
        return {
            ...state,
            dashboards: dashboards,
            isDirty: false,
            currentDashboardId: selectedDashboardId,
            error: ''
        };
    }),
    on(actions.loadDashboardByIdSuccess, (state, action): dashboardState => {
      let dashboards = state.dashboards.map(d => {
        let newD = action.dashboards.find(o => o.id == d.id);
        if (newD != null) {
          return ({ ...d, tabs: newD.tabs });
        }
        return d;
      })
      return {
        ...state,
        dashboards: dashboards
      };
    }),
    on(actions.loadFailure, (state, action): dashboardState => {
        return {
            ...state,
            error: action.error
        };
    })
);

function getUniqueDashboardId(dash: dashboard[]): number {
    let result:number;
    for (let i = 0; i < 10; i++) {
         result = Math.floor(Math.random() * 10000) + 10000000;
        if(dash.filter((d)=>d.id==result).length==0)  break;
    }
    return result;
};

function getUniqueTabId(dash: dashboard[]): number {
    let result: number;
    for (let i = 0; i < 10; i++) {
      result = Math.floor(Math.random() * 10000) + 10000000;
      let ids: number[] = dash.flatMap(a => a.tabs).map(a => a.id);
      if (ids.indexOf(result) < 0) break;
    }
    return result;
};

function getUniqueGridItemId(dash: dashboard[]): number {
    let result:number;
    for (let i = 0; i < 10; i++) {
         result = Math.floor(Math.random() * 10000) + 10000000;
        let ids:number[] = dash.flatMap(a => a.tabs).flatMap(a=>a.gridItems).map(a=>a.id);
        if(ids.indexOf(result)<0)  break;
    }
    return result;
};
